import { render, staticRenderFns } from "./MoveUnitPulldown.vue?vue&type=template&id=af3bd89e&"
import script from "./MoveUnitPulldown.vue?vue&type=script&lang=js&"
export * from "./MoveUnitPulldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports